export default __webpack_public_path__ + "static/media/logo-fnr.78df6947.svg";